<template>
	<div>
		<header class="modal-card-head">
			<h4 class="modal-card-title">
				<span>
					<span>{{ $tc('labels.pick') }} </span>
					<strong>{{ $tc('menu.lawyers') }}</strong>
				</span>
			</h4>
		</header>

		<div class="modal-card-body is-sm">
			<b-loading :is-full-page="false" v-model="isOpening"></b-loading>

			<div class="modal-card mb-3">
				<b-field>
					<b-input
						v-model="nameLawyer"
						size="is-medium"
						name="search-lawyer"
						type="text"
						autocomplete="no"
						placeholder="Qual o nome do Advogado?"
					></b-input>
				</b-field>

				<ul class="list-lawyers">
					<li
						v-for="l in lawyers.filter(item => item && item.lawyer)"
						:key="l.id"
						class="lawyer-item"
					>
						<div class="lawyer-header">
							<span class="lawyer-name">
								{{ getLawyerName(l) }}
							</span>

							<b-collapse :open="false" animation="slide">
								<template #trigger="props">
									<button
										type="button"
										class="arrow"
									>
										<svg-icon
											icon="down"
											class="icon arrow-icon"
											:class="{ 'is-open': props.open }"
										></svg-icon>
									</button>
								</template>

								<div class="lawyer-details">
									<div class="details-grid">
										<div class="detail-card">
											<small>E-mail</small>
											<p>{{ l.email || 'Não informado' }}</p>
										</div>

										<div class="detail-card">
											<small>OAB</small>
											<p>{{ l.lawyer.oab || 'Não informado' }}</p>
										</div>

										<div class="detail-card">
											<small>Escritório</small>
											<p>{{ l.lawyer.office || 'Não informado' }}</p>
										</div>

										<div class="detail-card">
											<small>Cidade</small>
											<p>{{ l.lawyer.city || 'Não informado' }}</p>
										</div>

										<div class="detail-card">
											<small>Estado</small>
											<p>{{ l.lawyer.state || 'Não informado' }}</p>
										</div>
									</div>

									<div class="lawyer-actions">
										<button
											type="button"
											class="button is-primary is-small"
											@click.stop="selectLawyer(l)"
										>
											Selecionar
										</button>

										<a
											:href="`/lawyers/edit/${l.id}`"
											class="button is-light is-small"
											target="_blank"
										>
											<span>Detalhes do Advogado</span>

											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
												<path d="M23.78,27H8.22A3.23,3.23,0,0,1,5,23.78V8.22A3.23,3.23,0,0,1,8.22,5h4.46V7H8.22A1.22,1.22,0,0,0,7,8.22V23.78A1.22,1.22,0,0,0,8.22,25H23.78A1.22,1.22,0,0,0,25,23.78V19.5h2v4.28A3.23,3.23,0,0,1,23.78,27Z"/>
												<path d="M27,14.89H25V7H17.11V5H25a2,2,0,0,1,2,2Z"/>
												<rect x="14.06" y="10.33" width="13.22" height="2" transform="translate(-1.95 17.94) rotate(-45)"/>
											</svg>
										</a>
									</div>
								</div>
							</b-collapse>
						</div>
					</li>
				</ul>

				<p
					v-if="!isOpening && lawyers.length === 0"
					class="empty-message"
				>
					Nenhum advogado encontrado.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/Icon'
import Api from '@/services/api'
import eventHub from '@/services/eventHub'
import '@/mixins/generic'

export default {
	components: {
		'svg-icon': Icon
	},

	props: {
		lawsuitId: {
			type: Number,
			required: false
		},

		root: {
			type: String,
			required: false
		}
	},

	data() {
		return {
			lawyers: [],
			isOpening: false,
			loading: false,
			role: 1,
			permission: [],
			visible: false,
			nameLawyer: ''
		}
	},

	methods: {
		async getLawyers() {
			this.isOpening = true

			try {
				let url = 'lawyers/selectWithDetails'

				if (this.nameLawyer) {
					url += `?q=${encodeURIComponent(this.nameLawyer)}`
				}

				const response = await Api.get(url)
				const { status, data } = response

				console.log('RETORNO ADVOGADOS ORIGINAL:', data)

				if (status === 200) {
					this.lawyers = Array.isArray(data)
						? data.filter(item => item && item.lawyer !== null)
						: []

					console.log('RETORNO ADVOGADOS FILTRADO:', this.lawyers)
				} else {
					this.lawyers = []
				}
			} catch (e) {
				console.log('ERRO AO BUSCAR ADVOGADOS:', e)
				this.lawyers = []
			} finally {
				this.isOpening = false
			}
		},

		getLawyerName(item) {
			if (!item) {
				return 'Nome não informado'
			}

			if (item.full_name) {
				return item.full_name
			}

			const firstName = item.first_name || ''
			const lastName = item.last_name || ''
			const name = `${firstName} ${lastName}`.trim()

			return name || 'Nome não informado'
		},

		async selectLawyer(item) {
			const lawyerId = item && item.lawyer ? item.lawyer.id : null

			if (!this.lawsuitId || !lawyerId) {
				console.log('Dados inválidos ao selecionar advogado:', {
					lawsuitId: this.lawsuitId,
					item
				})

				return
			}

			eventHub.$emit('set-lawyer-lawsuit', {
				lawsuitId: this.lawsuitId,
				lawyerId
			})

			this.$emit('close')
		}
	},

	mounted() {
		this.getLawyers()
	},

	watch: {
		nameLawyer(v) {
			if (!v || v.length > 1) {
				this.getLawyers()
			}
		}
	}
}
</script>

<style scoped>
.list-lawyers {
	margin-top: 10px;
}

.lawyer-item {
	padding: 8px 0;
	border-bottom: 1px solid #eeeeee;
}

.lawyer-header {
	display: grid;
	grid-template-columns: 1fr auto;
	align-items: start;
	column-gap: 10px;
}

.lawyer-name {
	display: block;
	min-height: 32px;
	line-height: 32px;
	color: #777777;
	font-size: 15px;
	cursor: default;
	user-select: none;
}

.arrow {
	width: 40px;
	height: 32px;
	border: 1px solid #bdbdbd;
	border-radius: 3px;
	background: #f5f5f5;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.arrow:hover {
	background: #e9e9e9;
}

.arrow-icon {
	transition: transform 0.2s ease;
}

.arrow-icon.is-open {
	transform: rotate(180deg);
}

.lawyer-details {
	grid-column: 1 / -1;
	margin-top: 10px;
	padding: 14px;
	border: 1px solid #e2e2e2;
	border-radius: 8px;
	background: #fafafa;
}

.details-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
}

.detail-card {
	padding: 10px;
	border: 1px solid #eeeeee;
	border-radius: 6px;
	background: #ffffff;
}

.detail-card small {
	display: block;
	margin-bottom: 4px;
	color: #888888;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
}

.detail-card p {
	margin: 0;
	color: #555555;
	font-size: 14px;
	word-break: break-word;
}

.lawyer-actions {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 8px;
	margin-top: 14px;
}

.lawyer-actions .button svg {
	width: 14px;
	height: 14px;
	margin-left: 6px;
}

.empty-message {
	margin-top: 12px;
	color: #999999;
	font-size: 14px;
}

@media (max-width: 768px) {
	.details-grid {
		grid-template-columns: 1fr;
	}

	.lawyer-actions {
		flex-direction: column;
		align-items: stretch;
	}

	.lawyer-actions .button {
		width: 100%;
	}
}
</style>